import type { PropsWithChildren } from "react";
import { CommandPalette } from "../shared/components/CommandPalette";
import { CurrentUserProvider } from "../shared/auth/CurrentUserProvider";
import type { CurrentUser } from "../shared/auth/CurrentUserContext";

export function AppShell({
  children,
  user,
}: PropsWithChildren<{ user: CurrentUser }>) {
  return (
    <>
      <CurrentUserProvider user={user}>{children}</CurrentUserProvider>
      <CommandPalette />
    </>
  );
}
